import { NavLink } from 'react-router-dom';
import { IconType } from 'react-icons';
import { FaCog, FaFileContract, FaFolderOpen, FaSearch, FaSyncAlt, FaThLarge, FaUserShield } from 'react-icons/fa';
import { PAS_NAV } from '../constants';
import { cn } from '../../../utils/cn';

const ICONS: Record<string, IconType> = {
  dashboard: FaThLarge,
  policies: FaFileContract,
  underwriting: FaUserShield,
  renewals: FaSyncAlt,
  documents: FaFolderOpen,
  search: FaSearch,
  administration: FaCog,
};

export const PolicyAdminNav: React.FC = () => (
  <nav
    className="mb-6 flex gap-1 overflow-x-auto border-b"
    style={{ borderColor: 'var(--color-border-light)' }}
    aria-label="Policy administration sections"
  >
    {PAS_NAV.map((item) => {
      const Icon = ICONS[item.icon] ?? FaThLarge;
      return (
        <NavLink
          key={item.key}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            cn(
              'flex items-center gap-2 whitespace-nowrap border-b-2 px-3.5 py-2.5 text-sm font-semibold transition-colors',
              isActive ? 'border-current' : 'border-transparent hover:opacity-80',
            )
          }
          style={({ isActive }) => ({
            color: isActive ? 'var(--color-primary-600)' : 'var(--color-text-secondary)',
          })}
        >
          <Icon className="h-4 w-4" />
          {item.label}
        </NavLink>
      );
    })}
  </nav>
);
